import { Card, Grid, Typography } from '@mui/material';
import styles from '../Information/Information.module.scss'
import { CommonOutlinedButton, CustomLeftIcon } from '../common/StyledComponents/StyledFields';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequest, catchErrorMessageHandler } from '../../infrastructure/backendService';
import toast from 'react-hot-toast';
import ToastError from '../common/toast/toastError';
import Avatar from '@mui/material/Avatar';
import userAvathar from '../../assets/userAvathar.png';
import { isNil } from 'lodash';
import apiPath from "../../config/apiPaths.json";
import ErrorPopup from '../common/ErrorPopup';
import constants from "../../config/constants.json";

const Priests = () => {
    const [priestBioList, setPriestBioList] = useState<any[]>([]);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const navigation = useNavigate();
    const handlebackClick = () => {
        navigation('/overview');
    }
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page
        // Find the specific heading element by its ID or class name
        const priests = document.getElementById('priests');
        if (priests) {
            priests.scrollIntoView({ behavior: 'smooth' }); // Scroll to the top
        }
    }, []);
    useEffect(() => {
        apiRequest({
            method: "GET",
            endpoint: apiPath.priestBioApi,
            includeToken: true,
        })
            .then((res) => {
                console.log(res.data, "priesttttttttttttlisttttttt");
                setPriestBioList(res.data.content);
            })
            .catch((err) => {
                console.log(err);
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                  });
            });
    }, []);

    const handlePrint = () => {
        window.print();
    };

    const priestBioDetails = [
        {
            "image": "/images/priest3.jpg",
            "name": "PT. Ramanujam Kannan",
            "description": "This is the first sample image with a description.",
            "language": "English"
        },
        {
            "image": "https://example.com/image2.jpg",
            "name": "Image 2",
            "description": "This is the second sample image with a description.",
            "language": "Spanish"
        },
        {
            "image": "https://example.com/image3.jpg",
            "name": "Image 3",
            "description": "This is the third sample image with a description.",
            "language": "French"
        }
    ]

    const priestComponent = (): React.ReactElement => {

        return (
            <>
                {priestBioList.map((item, index) => (
                    <div className={styles.priestscontainer}>
                        <Grid key={index} className={styles.properspace}>
                            {/* <img src={item.imageName} className={styles.priestImage} alt={"image"} /> */}
                            <img
                                src={item.imageName || userAvathar}
                                className={styles.priestImage}
                                alt={item.imageName ? "image" : "Delete Icon"}
                            />
                            <div className={styles.properalign}>
                                <Typography className={styles.priestName}>{item.name}</Typography>
                                <Typography
                                    className={styles.content}
                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                />
                            </div>
                        </Grid>
                    </div >
                ))}
            </>
        )
    }
    return (
        <div className={styles.PriestTotalLayout}>
            <Typography className={styles.typoGraphyHeading}>
                <span style={{ marginRight: "10px" }} onClick={handlebackClick}>
                    <CustomLeftIcon />
                </span>
                <span style={{ float: "right" }} onClick={handlePrint}><CommonOutlinedButton>Print</CommonOutlinedButton></span>
                Priests
            </Typography>
            <Card className={styles.cardContainer}>
                {priestComponent()}
            </Card>
        </div>
    )
}
export default Priests;